"use client";
import { Inter } from "next/font/google";
const interStyle = Inter({
  weight: ["400", "500", "700", "800", "900"],
  subsets: ["latin"],
});
import useKeypress from "@wt/shared/hooks/useKeyPress";
import {ChangeEvent, ReactNode, useEffect, useRef, useState} from "react";

export default function ModalLayout(props: {
  children: ReactNode;
  htmlFor: string;
}) {
  const [visible, setVisible] = useState<boolean>(false);

  useKeypress("Escape", () => {
    const t = document.getElementById(props.htmlFor);
    if (t instanceof HTMLInputElement) {
      if (t.type === "checkbox") {
        if (t.checked) {
          t.click();
        }
      }
    }
  });
  const modalToggleRef = useRef<HTMLInputElement | null>(null);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget && e.currentTarget instanceof HTMLInputElement) {
      setVisible(e.currentTarget.checked);
    }
  }
  useEffect(() => {
      if (modalToggleRef.current && modalToggleRef.current instanceof  HTMLInputElement) {
        setVisible(modalToggleRef.current.checked);
      }
  }, [modalToggleRef]);

  return (
    <>
      <input
        type="checkbox"
        onChange={onChange}
        id={props.htmlFor}
        ref={modalToggleRef}
        className="modal-toggle"
      />
      <div className="modal" style={interStyle.style}>
        <div className="modal-box fixed inset-0 z-[9999] m-0 flex size-full max-h-full max-w-full flex-col justify-between gap-4 rounded-none p-0">
          {visible && props.children}
        </div>
      </div>
    </>
  );
}
